// Front-end demo products shown when the product API returns nothing
// (e.g. while the backend is offline). Swap/remove once the API is live.
import male from "../assets/male.png";
import female from "../assets/female.png";
import landing from "../assets/landingPhoto.png";
import ring from "../assets/ring.png";
import bloc from "../assets/bloc.png";
import blocc6 from "../assets/blocc6.png";
import upCy from "../assets/upCy.png";
import blo from "../assets/blo.png";
import home from "../assets/home.png";

// Shop-by taxonomy (kept in one place so filters + nav stay in sync)
export const GENDERS = ["Men", "Women"];
export const COLLECTIONS = [
  "The Challengers",
  "Women Should Be Gods",
  "Military Coup Deluxe",
];
export const CATEGORIES = [
  "Shirts & Jackets",
  "Tees",
  "Pants",
  "Headwear",
  "Bags & Accessories",
];

export const demoProducts = [
  {
    id: "lm-01",
    _id: "lm-01",
    name: "Ion Shell Jacket",
    price: 145000,
    image: blocc6,
    images: [blocc6, male],
    rating: 5,
    numReviews: 24,
    brand: "LORMAMI",
    gender: "Men",
    collection: "The Challengers",
    category: "Shirts & Jackets",
    isFeatured: true,
    outOfStock: false,
    description:
      "Weather-ready technical shell with a sculpted collar and matte hardware.",
  },
  {
    id: "lm-02",
    _id: "lm-02",
    name: "Orbit Cargo Trouser",
    price: 92000,
    image: bloc,
    images: [bloc, landing],
    rating: 4,
    numReviews: 18,
    brand: "LORMAMI",
    gender: "Men",
    collection: "Military Coup Deluxe",
    category: "Pants",
    isFeatured: true,
    outOfStock: false,
    description: "Relaxed cargo trouser with articulated knees and utility pockets.",
  },
  {
    id: "lm-03",
    _id: "lm-03",
    name: "Pulse Knit",
    price: 68000,
    image: ring,
    images: [ring, female],
    rating: 5,
    numReviews: 31,
    brand: "LORMAMI",
    gender: "Women",
    collection: "Women Should Be Gods",
    category: "Tees",
    isFeatured: true,
    outOfStock: false,
    description: "Midweight ribbed knit in a clean, future-facing silhouette.",
  },
  {
    id: "lm-04",
    _id: "lm-04",
    name: "Vector Overshirt",
    price: 110000,
    image: landing,
    images: [landing, blo],
    rating: 4,
    numReviews: 12,
    brand: "LORMAMI",
    gender: "Men",
    collection: "The Challengers",
    category: "Shirts & Jackets",
    isFeatured: true,
    outOfStock: false,
    description: "Structured overshirt that layers as easily as it stands alone.",
  },
  {
    id: "lm-05",
    _id: "lm-05",
    name: "Signal Tee",
    price: 42000,
    image: male,
    images: [male, blocc6],
    rating: 4,
    numReviews: 40,
    brand: "LORMAMI",
    gender: "Men",
    collection: "The Challengers",
    category: "Tees",
    isFeatured: false,
    outOfStock: false,
    description: "Heavyweight cotton tee with a soft hand and a boxy fit.",
  },
  {
    id: "lm-06",
    _id: "lm-06",
    name: "Nova Field Pant",
    price: 88000,
    image: female,
    images: [female, ring],
    rating: 5,
    numReviews: 9,
    brand: "LORMAMI",
    gender: "Women",
    collection: "Women Should Be Gods",
    category: "Pants",
    isFeatured: false,
    outOfStock: true,
    description: "Tapered field pant with a comfort waistband and clean seams.",
  },
  {
    id: "lm-07",
    _id: "lm-07",
    name: "Reclaim Denim Jacket",
    price: 120000,
    image: upCy,
    images: [upCy, bloc],
    rating: 5,
    numReviews: 7,
    brand: "UPCYCLED COLLECTION",
    gender: "Men",
    collection: "Military Coup Deluxe",
    category: "Shirts & Jackets",
    isFeatured: false,
    outOfStock: false,
    description: "One-of-one reworked denim, hand-finished from reclaimed material.",
  },
  {
    id: "lm-08",
    _id: "lm-08",
    name: "Salvage Parka",
    price: 160000,
    image: blo,
    images: [blo, upCy],
    rating: 4,
    numReviews: 5,
    brand: "UPCYCLED COLLECTION",
    gender: "Women",
    collection: "Military Coup Deluxe",
    category: "Shirts & Jackets",
    isFeatured: false,
    outOfStock: false,
    description: "Patchwork parka built from salvaged shells — no two alike.",
  },
  {
    id: "lm-09",
    _id: "lm-09",
    name: "Deluxe Field Cap",
    price: 28000,
    image: home,
    images: [home, blocc6],
    rating: 4,
    numReviews: 14,
    brand: "LORMAMI",
    gender: "Men",
    collection: "Military Coup Deluxe",
    category: "Headwear",
    isFeatured: false,
    outOfStock: false,
    description: "Structured six-panel cap with an embroidered insignia.",
  },
  {
    id: "lm-10",
    _id: "lm-10",
    name: "Insignia Tote",
    price: 35000,
    image: ring,
    images: [ring, blo],
    rating: 5,
    numReviews: 11,
    brand: "LORMAMI",
    gender: "Women",
    collection: "The Challengers",
    category: "Bags & Accessories",
    isFeatured: false,
    outOfStock: false,
    description: "Roomy canvas tote with reinforced straps and a printed crest.",
  },
  {
    id: "lm-11",
    _id: "lm-11",
    name: "Goddess Crop Tee",
    price: 46000,
    image: female,
    images: [female, landing],
    rating: 5,
    numReviews: 22,
    brand: "LORMAMI",
    gender: "Women",
    collection: "Women Should Be Gods",
    category: "Tees",
    isFeatured: false,
    outOfStock: false,
    description: "Cropped tee with a sculpted neckline and premium jersey.",
  },
  {
    id: "lm-12",
    _id: "lm-12",
    name: "Coup Utility Pant",
    price: 96000,
    image: landing,
    images: [landing, bloc],
    rating: 4,
    numReviews: 8,
    brand: "LORMAMI",
    gender: "Men",
    collection: "Military Coup Deluxe",
    category: "Pants",
    isFeatured: false,
    outOfStock: false,
    description: "Heavy-duty utility pant with map pockets and a tapered leg.",
  },
];

export const demoFeatured = demoProducts.filter((p) => p.isFeatured);
export const demoUpcycled = demoProducts.filter(
  (p) => p.brand === "UPCYCLED COLLECTION"
);
export const demoMainline = demoProducts.filter(
  (p) => p.brand !== "UPCYCLED COLLECTION"
);
